export default __webpack_public_path__ + "static/media/reservation_v2_bg.00c09e01.jpg";